import { Building2, DollarSign, FolderGit2, Users, ShieldCheck } from 'lucide-react';
import MetricCard from '../MetricCard';

interface CompanyStatsProps {
  totalCompanies: number;
  activeCompanies: number;
  totalRevenue: number;
  totalProjects: number;
  totalClients: number;
}

export default function CompanyStats({ totalCompanies, activeCompanies, totalRevenue, totalProjects, totalClients }: CompanyStatsProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <MetricCard 
        title="Empresas"
        value={totalCompanies}
        trend="+12 este mês"
        trendUp={true}
        subtext="Empresas no ecossistema"
        icon={Building2}
        color="text-indigo-600"
        bg="bg-indigo-50/80"
        secondaryLabel="Operação ativa"
        secondaryValue={`${activeCompanies} de ${totalCompanies}`}
        progress={totalCompanies > 0 ? Math.round((activeCompanies / totalCompanies) * 100) : 100}
        progressColor="bg-indigo-600"
      />
      <MetricCard 
        title="Receita"
        value={`R$ ${totalRevenue.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`}
        trend="+18%"
        trendUp={true}
        subtext="Faturamento consolidado"
        icon={DollarSign}
        color="text-emerald-600"
        bg="bg-emerald-50/80"
        secondaryLabel="Atingimento"
        secondaryValue="92%"
        progress={92}
        progressColor="bg-emerald-500"
      />
      <MetricCard 
        title="Projetos"
        value={totalProjects}
        trend="+4 concluídos"
        trendUp={true}
        subtext="Ativos nas organizações"
        icon={FolderGit2}
        color="text-purple-600"
        bg="bg-purple-50/80"
        secondaryLabel="Entregas no prazo"
        secondaryValue="88%"
        progress={88}
        progressColor="bg-purple-600"
      />
      <MetricCard 
        title="Clientes"
        value={totalClients}
        trend="+2 hoje"
        trendUp={true}
        subtext="Usuários e contas atendidas"
        icon={Users}
        color="text-amber-600"
        bg="bg-amber-50/80"
        secondaryLabel="Retenção global"
        secondaryValue="95%"
        progress={95}
        progressColor="bg-amber-500"
      />
      <MetricCard 
        title="Governança BES"
        value="3.2k"
        trend="+120 pts"
        trendUp={true}
        subtext="Score de saúde corporativa"
        icon={ShieldCheck}
        color="text-blue-600"
        bg="bg-blue-50/80"
        secondaryLabel="Conformidade"
        secondaryValue="96%"
        progress={96}
        progressColor="bg-blue-600"
      />
    </div>
  );
}

